import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutionsSection } from './components/FailedSolutionsSection';
import { CTASection } from './components/CTASection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream-light selection:bg-terracotta/20 selection:text-brown" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <OpeningHook data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <FailedSolutionsSection data-id="element-5" />
        <CTASection data-id="element-6" />
        <PricingSection data-id="element-7" />
      </main>

      <Footer data-id="element-8" />
    </div>;
}